import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ToastController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PessoaProvider } from 'src/app/services/pessoa/pessoa';

@Component({
  selector: 'app-anotacao-edit',
  templateUrl: './anotacao-edit.page.html',
  styleUrls: ['./anotacao-edit.page.scss'], 
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule
  ],
})
export class AnotacaoEditPage implements OnInit {
  validations_form: FormGroup;
  validation_messages = {
    'anotacao': [
      { type: 'required', message: this.translate.instant('Campo Obrigatório') }
    ]
  };
  titulo: string;
  anotacao: any = '';
  id: any = '';
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private translate: TranslateService,
    public pessoaProvider: PessoaProvider
  ) {
    this.anotacao = this.navParams.get('anotacao');
    this.id = this.navParams.get('id');
    this.titulo = navParams.get('entidade');
    this.validations_form = this.formBuilder.group({
      anotacao: new FormControl(this.anotacao,[Validators.required, Validators.pattern(/^(?!\s*$).+/)]),
      id: new FormControl(this.id, Validators.required),
    });
  }

  ngOnInit() {
  }

  setFormValue(field: string | number, form: any) {
    this.validations_form.controls[field].setValue(form);
  }

  onSubmit(form: { id: any; anotacao: any; }) {
    this.pessoaProvider.editAnotacao(form.id, form.anotacao).subscribe(async data => {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Anotação alterada com sucesso!'),
        duration: 3000
      });

      toast.present();

      this.modalCtrl.dismiss(data);
    });
  }

  public closeModal(){
    this.modalCtrl.dismiss();
  }
}
